import Swal from 'sweetalert2';

/**
 * Open a popup requiring the customer to select a dealer. Return a Promise
 * @param options (optional) options
 * @param options.title (optional) The title for the popup.
 * @param options.locationData (optional) A location data object to use instead of the standard
 * @param options.additionalHtml (optional) Additional HTML to appear before the form
 * @param options.returnFullDealer (optional) Return the full dealer object instead of just the ID
 */
export default async function(options = {}) {
    return new Promise((resolve, reject) => {
        const title = options.title || 'Select your nearest dealer';
        const additionalHtml = options.additionalHtml || '';
        const returnFullDealer = (options.returnFullDealer && options.returnFullDealer === true) ? true : false;
        const now = Date.now();
        const locationIcon = (typeof brand != 'undefined' && brand == 'ds') ? '/images/use-my-location-ds.svg' : '/images/use-my-location.svg';

        let locationData = [];
        let validator, locationHandler;

        const selectDealerModal = Swal.fire({
            title: title,
            html: `
                <form class="material-form relative" method="GET" action="/" id="selectYourNearestDealer${now}"  data-form-name="Select your nearest dealer">
                    ${additionalHtml}
                    <div class="form-inline">
                        <div class="form-group">
                            <input class="form-control" type="text" name="location" id="selectYourNearestDealer${now}-location" value="" data-validate-message="Please enter your Postcode/Town" data-validate="input" data-location-element="true" data-customer-location="true" data-location-target="#selectYourNearestDealer${now}-dealer" id="selectYourNearestDealer${now}-location" />
                            <label for="selectYourNearestDealer${now}-location">Postcode/Town *</label>
                            <span class="input-border"></span>
                            <img class="use-my-location" src="${locationIcon}" data-location-element="true" data-geolocation="true" data-location-target="#selectYourNearestDealer${now}-dealer" />
                        </div>
                    </div>
                    <div class="form-inline">
                        <div class="form-group">
                            <select data-validate="select" class="form-control" data-validate-message="Please select a dealer" name="location-id" id="selectYourNearestDealer${now}-dealer" data-location-element="true" data-location-list="true" data-populate-dealers="true" data-no-default-text="true">
                                <option value=""></option>
                            </select>
                            <label for="selectYourNearestDealer${now}-dealer">Dealer *</label>
                            <span class="input-border"></span>
                        </div>
                    </div>
                </form>
            `,
            onOpen: async modalElement => {
                const form = modalElement.querySelector('form');
                if (!form) {
                    console.error('resources/assets/js/modules/dealer-locators/select-nearest-dealer-popup.js - Unable to find form inside modal');
                    reject();
                    return;
                }

                if (options.locationData) {
                    locationData = options.locationData;
                } else {
                    locationData = await window.LocationDataLoader.get();
                }

                validator = new ContactFormValidator({ element: form });
                locationHandler = new CustomerLocationHandler();
                locationHandler.setLocationData(locationData);
                locationHandler.setup(form.getAttribute('id'));
            },
            showCloseButton: true,
            showCancelButton: false,
            confirmButtonText: 'Continue',
            showLoaderOnConfirm: false,
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary',
            },
            preConfirm: async () => {
                if (!await validator.isValid(null, true)) {
                    return false;
                }
                const locationId = validator.formElement[0].querySelector('select[name="location-id"]').value;
                if (returnFullDealer === true) {
                    for (let index = 0, len = locationData.length; index < len; index++) {
                        if (locationData[index].id == locationId) {
                            return locationData[index];
                        }
                    }
                    console.error('Unable to find dealer in list of all dealers', locationId, locationData);
                    return false;
                }
                return locationId;
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then(result => {
            if (result.isConfirmed) {
                resolve(result.value);
                return;
            }
            reject();
        }).catch(error => {
            reject(error);
        })
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/dealer-locators/select-nearest-dealer-popup.js